"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _reactMapGl = _interopRequireWildcard(require("react-map-gl"));

var _reactDimensions = _interopRequireDefault(require("react-dimensions"));

var _core = require("@emotion/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createRef = _interopRequireDefault(require("create-react-ref/lib/createRef"));

var _reactMapGlGeocoder = _interopRequireDefault(require("react-map-gl-geocoder"));

var _lodash = require("lodash");

var _bbox = _interopRequireDefault(require("@turf/bbox"));

var _viewportMercatorProject = _interopRequireDefault(require("viewport-mercator-project"));

var _mapboxgl = _interopRequireDefault(require("./mapboxgl"));

require("mapbox-gl/dist/mapbox-gl.css");

var _index = require("../_Themes/index");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  bottom: 0;\n  right: 0;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  bottom: 0;\n  left: 0;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  top: 0;\n  left: 0;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  top: 0;\n  right: 0;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  margin: 5px 25px 35px 45px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  z-index: 1;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  margin: 0 auto;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var MAPBOX_TOKEN = _index.MapGLResources.MAPBOX_TOKEN,
    CIVIC_LIGHT = _index.MapGLResources.CIVIC_LIGHT,
    CIVIC_DARK = _index.MapGLResources.CIVIC_DARK,
    CIVIC_PENCIL = _index.MapGLResources.CIVIC_PENCIL,
    DISASTER_GAME = _index.MapGLResources.DISASTER_GAME,
    SANDBOX_DARK = _index.MapGLResources.SANDBOX_DARK;
var mapWrapper = (0, _core.css)(_templateObject());
var navControl = (0, _core.css)(_templateObject2());
var geoCoderWrapper = (0, _core.css)(_templateObject3());
var topRight = (0, _core.css)(_templateObject4());
var topLeft = (0, _core.css)(_templateObject5());
var bottomLeft = (0, _core.css)(_templateObject6());
var bottomRight = (0, _core.css)(_templateObject7());

var BaseMap = function (_Component) {
  _inherits(BaseMap, _Component);

  function BaseMap(props) {
    var _this;

    _classCallCheck(this, BaseMap);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BaseMap).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onHover", function (_ref) {
      var object = _ref.object,
          x = _ref.x,
          y = _ref.y;

      _this.setState({
        tooltipInfo: object,
        x: x,
        y: y
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onViewportChange", function (viewport) {
      var _this$props = _this.props,
          minZoom = _this$props.minZoom,
          maxZoom = _this$props.maxZoom;
      var zoom = viewport.zoom;

      if (zoom >= minZoom && zoom <= maxZoom) {
        _this.setState(function (prevState) {
          return {
            viewport: _objectSpread({}, prevState.viewport, viewport)
          };
        });
      } else if (zoom < minZoom) {
        _this.setState(function (prevState) {
          return {
            viewport: _objectSpread({}, prevState.viewport, {
              zoom: minZoom
            })
          };
        });
      } else if (zoom > maxZoom) {
        _this.setState(function (prevState) {
          return {
            viewport: _objectSpread({}, prevState.viewport, {
              zoom: maxZoom
            })
          };
        });
      }
    });

    _this.state = {
      viewport: {
        longitude: props.initialLongitude,
        latitude: props.initialLatitude,
        zoom: props.initialZoom,
        minZoom: props.minZoom,
        maxZoom: props.maxZoom,
        pitch: props.initialPitch,
        bearing: 0
      },
      tooltipInfo: null,
      x: null,
      y: null,
      mounted: false
    };
    _this.mapRef = (0, _createRef["default"])();
    _this.geocoderContainerRef = (0, _createRef["default"])();
    return _this;
  }

  _createClass(BaseMap, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        mounted: true
      });
      var _this$props2 = this.props,
          bboxData = _this$props2.bboxData,
          bboxPadding = _this$props2.bboxPadding,
          boundBox = _this$props2.boundBox;
      var viewport = this.state.viewport;

      if (bboxData.length > 0) {
        var toGeoJSON = {
          type: "FeatureCollection",
          features: _toConsumableArray(bboxData)
        };
        var boundingBox = (0, _bbox["default"])(toGeoJSON);
        var bboxViewport = new _viewportMercatorProject["default"]({
          width: viewport.width,
          height: viewport.height
        }).fitBounds([[boundingBox[0], boundingBox[1]], [boundingBox[2], boundingBox[3]]], {
          padding: bboxPadding
        });
        this.onViewportChange(bboxViewport);
      }

      if (boundBox.length === 4) {
        var _bboxViewport = new _viewportMercatorProject["default"]({
          width: viewport.width,
          height: viewport.height
        }).fitBounds([[boundBox[0], boundBox[1]], [boundBox[2], boundBox[3]]], {
          padding: bboxPadding
        });

        this.onViewportChange(_bboxViewport);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(props) {
      var updateViewport = props.updateViewport;

      if (updateViewport) {
        var updatedViewportProps = {
          zoom: props.initialZoom,
          pitch: props.initialPitch,
          longitude: props.initialLongitude,
          latitude: props.initialLatitude
        };
        Object.keys(updatedViewportProps).forEach(function (key) {
          if (updatedViewportProps[key] == null) {
            delete updatedViewportProps[key];
          }
        });
        this.setState(function (prevState) {
          return {
            viewport: _objectSpread({}, prevState.viewport, updatedViewportProps)
          };
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevMapboxData = prevProps.mapboxData,
          prevMapboxLayerOptions = prevProps.mapboxLayerOptions,
          prevBoundBox = prevProps.boundBox;
      var _this$props3 = this.props,
          mapboxData = _this$props3.mapboxData,
          mapboxDataId = _this$props3.mapboxDataId,
          mapboxLayerOptions = _this$props3.mapboxLayerOptions,
          mapboxLayerId = _this$props3.mapboxLayerId,
          bboxData = _this$props3.bboxData,
          bboxPadding = _this$props3.bboxPadding,
          boundBox = _this$props3.boundBox;
      var viewport = this.state.viewport;

      if (!(0, _lodash.isEqual)(prevMapboxData, mapboxData)) {
        var map = this.mapRef.current.getMap();
        map.getSource(mapboxDataId).setData(mapboxData);
      }

      if (!(0, _lodash.isEqual)(prevMapboxLayerOptions, mapboxLayerOptions)) {
        var _map = this.mapRef.current.getMap();

        var updatedProperties = Object.keys(mapboxLayerOptions).filter(function (m) {
          return !(0, _lodash.isEqual)(prevMapboxLayerOptions[m], mapboxLayerOptions[m]);
        });
        updatedProperties.forEach(function (p) {
          return _map.setPaintProperty(mapboxLayerId, p, mapboxLayerOptions[p]);
        });
      }

      if (bboxData.length > 0 && !(0, _lodash.isEqual)(prevProps.bboxData, bboxData)) {
        var toGeoJSON = {
          type: "FeatureCollection",
          features: _toConsumableArray(bboxData)
        };
        var boundingbox = (0, _bbox["default"])(toGeoJSON);
        var bboxViewport = new _viewportMercatorProject["default"]({
          width: viewport.width,
          height: viewport.height
        }).fitBounds([[boundingbox[0], boundingbox[1]], [boundingbox[2], boundingbox[3]]], {
          padding: bboxPadding
        });
        this.onViewportChange(bboxViewport);
      }

      if (boundBox.length === 4 && !(0, _lodash.isEqual)(prevBoundBox, boundBox)) {
        var _bboxViewport2 = new _viewportMercatorProject["default"]({
          width: viewport.width,
          height: viewport.height
        }).fitBounds([[boundBox[0], boundBox[1]], [boundBox[2], boundBox[3]]], {
          padding: bboxPadding
        });

        this.onViewportChange(_bboxViewport2);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          viewport = _this$state.viewport,
          tooltipInfo = _this$state.tooltipInfo,
          x = _this$state.x,
          y = _this$state.y,
          mounted = _this$state.mounted;
      var _this$props4 = this.props,
          height = _this$props4.height,
          containerHeight = _this$props4.containerHeight,
          containerWidth = _this$props4.containerWidth,
          civicMapStyle = _this$props4.civicMapStyle,
          mapboxToken = _this$props4.mapboxToken,
          navigation = _this$props4.navigation,
          geocoder = _this$props4.geocoder,
          locationMarker = _this$props4.locationMarker,
          geocoderOptions = _this$props4.geocoderOptions,
          geocoderOnChange = _this$props4.geocoderOnChange,
          geocoderPosition = _this$props4.geocoderPosition,
          mapGLOptions = _this$props4.mapGLOptions,
          children = _this$props4.children,
          useContainerHeight = _this$props4.useContainerHeight,
          onBaseMapClick = _this$props4.onBaseMapClick,
          onBaseMapHover = _this$props4.onBaseMapHover,
          onBaseMapMouseOut = _this$props4.onBaseMapMouseOut,
          mapboxData = _this$props4.mapboxData,
          mapboxDataId = _this$props4.mapboxDataId,
          mapboxLayerType = _this$props4.mapboxLayerType,
          mapboxLayerOptions = _this$props4.mapboxLayerOptions,
          mapboxLayerId = _this$props4.mapboxLayerId,
          locationMarkerCoord = _this$props4.locationMarkerCoord,
          animate = _this$props4.animate,
          animationDuration = _this$props4.animationDuration,
          scaleBar = _this$props4.scaleBar,
          scaleBarOptions = _this$props4.scaleBarOptions,
          sharedViewport = _this$props4.sharedViewport,
          onSharedViewportChange = _this$props4.onSharedViewportChange,
          useScrollZoom = _this$props4.useScrollZoom,
          useFitBounds = _this$props4.useFitBounds,
          bboxData = _this$props4.bboxData;
      viewport.width = containerWidth || 500;
      viewport.height = useContainerHeight ? containerHeight : height;

      var childrenLayers = _react.Children.map(children, function (child) {
        var layerViewport = sharedViewport ? _objectSpread({}, viewport, sharedViewport) : viewport;
        return (0, _react.cloneElement)(child, {
          viewport: layerViewport,
          tooltipInfo: tooltipInfo,
          x: x,
          y: y,
          onHover: function onHover(info) {
            return _this2.onHover(info);
          }
        });
      });

      var onMapLoad = function onMapLoad() {
        var map = _this2.mapRef.current.getMap();

        if (scaleBar) {
          map.addControl(new _mapboxgl["default"].ScaleControl({
            maxWidth: scaleBarOptions.maxWidth,
            unit: scaleBarOptions.units
          }));
        }

        if (!mapboxData || !mapboxLayerType || !mapboxLayerOptions) return;
        map.addSource(mapboxDataId, {
          type: "geojson",
          data: mapboxData
        });
        map.addLayer({
          id: mapboxLayerId,
          type: mapboxLayerType,
          source: mapboxDataId,
          paint: mapboxLayerOptions
        }, "waterway-label");
      };

      var baseMapboxStyleURL = CIVIC_LIGHT;

      if (civicMapStyle === "dark") {
        baseMapboxStyleURL = CIVIC_DARK;
      } else if (civicMapStyle === "pencil") {
        baseMapboxStyleURL = CIVIC_PENCIL;
      } else if (civicMapStyle === "disaster-game") {
        baseMapboxStyleURL = DISASTER_GAME;
      } else if (civicMapStyle === "sandbox-dark") {
        baseMapboxStyleURL = SANDBOX_DARK;
      }

      var animationProps = !animate ? {} : {
        transitionDuration: animationDuration,
        transitionInterpolator: new _reactMapGl.FlyToInterpolator()
      };
      var boundingbox;

      if (useFitBounds && bboxData.length > 0) {
        var toGeoJSON = {
          type: "FeatureCollection",
          features: _toConsumableArray(bboxData)
        };
        boundingbox = (0, _bbox["default"])(toGeoJSON);
      }

      var finalViewport = sharedViewport ? _objectSpread({}, viewport, sharedViewport, {
        height: height,
        width: containerWidth
      }) : viewport;
      var geocoderPositions = {
        "top-left": topLeft,
        "top-right": topRight,
        "bottom-left": bottomLeft,
        "bottom-right": bottomRight
      };
      return (0, _core.jsx)("div", {
        css: mapWrapper
      }, (0, _core.jsx)("div", {
        ref: this.geocoderContainerRef,
        css: [geoCoderWrapper, geocoderPositions[geocoderPosition]]
      }), (0, _core.jsx)(_reactMapGl["default"], _extends({
        className: "MapGL"
      }, finalViewport, animationProps, {
        mapStyle: baseMapboxStyleURL,
        mapboxApiAccessToken: mapboxToken,
        onViewportChange: function onViewportChange(newViewport) {
          if (onSharedViewportChange) {
            onSharedViewportChange(newViewport);
          } else {
            _this2.onViewportChange(newViewport);
          }
        },
        ref: this.mapRef
      }, mapGLOptions, {
        onClick: onBaseMapClick,
        onHover: function onHover(baseInfo) {
          var baseMapboxRef = _this2.mapRef.current.getMap();

          if (onBaseMapHover) {
            onBaseMapHover(baseInfo, baseMapboxRef);
          }
        },
        onMouseOut: function onMouseOut() {
          var baseMapboxRef = _this2.mapRef.current.getMap();

          if (onBaseMapMouseOut) {
            onBaseMapMouseOut(baseMapboxRef);
          }
        },
        onBlur: function onBlur() {
          var baseMapboxRef = _this2.mapRef.current.getMap();

          if (onBaseMapMouseOut) {
            onBaseMapMouseOut(baseMapboxRef);
          }
        },
        onLoad: onMapLoad,
        scrollZoom: useScrollZoom
      }), (0, _core.jsx)("div", {
        css: navControl
      }, navigation && (0, _core.jsx)(_reactMapGl.NavigationControl, null)), locationMarker && (0, _core.jsx)(_reactMapGl.Marker, {
        latitude: locationMarkerCoord.latitude,
        longitude: locationMarkerCoord.longitude,
        offsetLeft: -20,
        offsetTop: -10
      }, (0, _core.jsx)("span", {
        role: "img",
        "aria-label": "star"
      }, "\u274C")), geocoder && mounted && (0, _core.jsx)(_reactMapGlGeocoder["default"], {
        mapRef: {
          current: this.mapRef.current
        },
        containerRef: this.geocoderContainerRef,
        mapboxApiAccessToken: mapboxToken,
        onViewportChange: function onViewportChange(newViewport) {
          _this2.onViewportChange(newViewport);

          !!geocoderOnChange && geocoderOnChange(newViewport);
        },
        bbox: boundingbox,
        position: geocoderPosition,
        options: _objectSpread({}, geocoderOptions)
      }), childrenLayers));
    }
  }]);

  return BaseMap;
}(_react.Component);

BaseMap.propTypes = {
  initialLongitude: _propTypes["default"].number,
  initialLatitude: _propTypes["default"].number,
  initialZoom: _propTypes["default"].number,
  minZoom: _propTypes["default"].number,
  maxZoom: _propTypes["default"].number,
  initialPitch: _propTypes["default"].number,
  height: _propTypes["default"].number,
  containerHeight: _propTypes["default"].number,
  containerWidth: _propTypes["default"].number,
  mapboxToken: _propTypes["default"].string,
  civicMapStyle: _propTypes["default"].oneOf(["light", "dark", "pencil", "disaster-game", "sandbox-dark"]),
  navigation: _propTypes["default"].bool,
  locationMarker: _propTypes["default"].bool,
  locationMarkerCoord: _propTypes["default"].shape({
    latitude: _propTypes["default"].number,
    longitude: _propTypes["default"].number
  }),
  geocoder: _propTypes["default"].bool,
  geocoderOptions: _propTypes["default"].shape({}),
  geocoderOnChange: _propTypes["default"].func,
  geocoderPosition: _propTypes["default"].oneOf(["top-left", "top-right", "bottom-left", "bottom-right"]),
  mapGLOptions: _propTypes["default"].shape({}),
  children: _propTypes["default"].node,
  useContainerHeight: _propTypes["default"].bool,
  updateViewport: _propTypes["default"].bool,
  animate: _propTypes["default"].bool,
  animationDuration: _propTypes["default"].number,
  onBaseMapClick: _propTypes["default"].func,
  onBaseMapHover: _propTypes["default"].func,
  onBaseMapMouseOut: _propTypes["default"].func,
  mapboxDataId: _propTypes["default"].string,
  mapboxData: _propTypes["default"].shape({
    type: _propTypes["default"].string,
    features: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
  }),
  mapboxLayerType: _propTypes["default"].string,
  mapboxLayerId: _propTypes["default"].string,
  mapboxLayerOptions: _propTypes["default"].shape({}),
  scaleBar: _propTypes["default"].bool,
  scaleBarOptions: _propTypes["default"].shape({
    maxWidth: _propTypes["default"].number,
    units: _propTypes["default"].string
  }),
  sharedViewport: _propTypes["default"].shape({}),
  onSharedViewportChange: _propTypes["default"].func,
  bboxData: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  bboxPadding: _propTypes["default"].number,
  boundBox: _propTypes["default"].arrayOf(_propTypes["default"].number),
  useScrollZoom: _propTypes["default"].bool,
  useFitBounds: _propTypes["default"].bool
};
BaseMap.defaultProps = {
  mapboxToken: MAPBOX_TOKEN,
  navigation: true,
  geocoder: false,
  geocoderPosition: "top-right",
  useContainerHeight: false,
  updateViewport: true,
  animate: false,
  initialLongitude: -122.6765,
  initialLatitude: 45.5231,
  initialZoom: 9.5,
  minZoom: 6,
  maxZoom: 20,
  initialPitch: 0,
  height: 500,
  locationMarkerCoord: {
    latitude: 0,
    longitude: 0
  },
  animationDuration: 1000,
  scaleBar: false,
  bboxData: [],
  bboxPadding: 10,
  boundBox: [],
  useScrollZoom: false
};

var _default = (0, _reactDimensions["default"])()(BaseMap);

exports["default"] = _default;